module.exports = __webpack_public_path__ + "media/images/trash-ab42c06bcca7942885dc4f21b9ff883a.svg";